const BASE_KEY: string = 'forshaw'

const buildKey = (key: string) => `${BASE_KEY}/${key}`

export const set = (key: string, value: any) =>
  localStorage.setItem(buildKey(key), value.toString())
export const get = (key: string, or: any = null): any =>
  localStorage.getItem(buildKey(key)) || or
export const remove = (key: string) => localStorage.removeItem(buildKey(key))
